enum PosterWidth {
  Small = '10rem',
  Default = '16.5rem',
  Large = '35.9rem',
}

export default PosterWidth;
